// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.private-offer-container {
  overflow-x: hidden;
  overflow-y: auto;
  position: relative;
  max-height: 80vh;
}
.private-offer-container form {
  padding-bottom: 0px !important;
}

.private-offer-container-wc {
  max-height: 50vh !important;
}

label {
  margin: 0;
}

.all-benefits-container {
  display: inline-block;
}

.offer {
  float: left;
  width: 100%;
  border-radius: 8px;
  border: 0.5px solid #CFDAE6;
  padding: 0px;
  overflow: hidden;
  margin-bottom: 35px;
}
.offer .offer-container {
  font-size: 16px;
  background-color: #ffffff !important;
  margin: 0 2%;
}
.offer .offer-container .ahorro-fala .cost-text {
  font-size: 24px;
  font-weight: bold;
  color: #2B8F14;
}
.offer .offer-container .ahorro-fala span {
  text-align: center;
  font-size: 12px;
}
.offer .offer-container .percent-text {
  text-align: right;
}

.offer-title {
  text-align: left;
  font-size: 22px;
  color: #2B8F14;
}

.offer-tax {
  color: #333537;
  font-size: smaller;
}

.offer-detail {
  margin: 25px 0 0 0;
  text-align: justify;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: -0.2625px;
  color: #8A9199;
  flex: none;
  order: 5;
  align-self: center;
}

.benefits-container.Ahorro {
  padding: 5px 0;
  height: 100%;
}

.benefits-container.Flex {
  padding: 10px 0;
}

.custom-divider-container {
  margin: 0 15px;
}
.custom-divider-container .custom-divider {
  background: #C9D4DF;
  height: 2px;
  border: none;
}

.benefit-img-container {
  display: flex;
  padding-left: 0;
  padding-right: 0;
  margin-right: 2px;
}

.all-benefits-container .benefits-container.CTS:nth-child(2) img {
  width: 100%;
  height: 100%;
  margin-right: 15px;
}

.benefits-container.CTS .benefit-icon-img {
  width: 70%;
  height: 80%;
  margin-left: 15px;
}

.benefit-icon-img {
  width: 100%;
  height: auto;
}

.benefit-description {
  display: flex;
  align-items: center;
  font-size: 14px;
  padding-right: 0px;
  color: #44474B;
}

.img-container-flex {
  margin: 35px 0 15px 0;
}

.offer-img {
  display: block;
  height: auto;
  border-radius: 7.7px;
  padding: 0 15px;
  margin: 0 auto 0 auto;
  width: 100%;
}

.offer-img-ahorro {
  width: 25%;
}

.offer-img-ahorro-sueldo {
  width: 25% !important;
}

.text-description {
  font-size: small;
}
.text-description.title {
  text-align: left;
  font-size: larger;
}

.flex {
  width: 90%;
}

.ahorro {
  width: 50%;
}

.offer-title-flex .principal-title-green {
  font-size: 20px;
  font-weight: unset;
}
.offer-title-flex span {
  font-size: 12px;
}

.offer-title-flex {
  text-align: center;
}

.AhorroSueldo {
  border: none !important;
  margin-bottom: 0px !important;
}
.AhorroSueldo .benefit-icon-img {
  width: 50%;
  height: auto;
  margin-bottom: 1rem;
}
.AhorroSueldo .benefit-description {
  margin-bottom: 1rem;
  margin-left: -1rem;
}
.AhorroSueldo .principal-title {
  text-align: center !important;
}

.text-start-ahorro-sueldo {
  text-align: left !important;
  margin-left: 0%;
  width: auto;
}

.wc-container .wc-container-in .green-text {
  color: #2B8F14;
  font-weight: normal;
}
.wc-container .wc-container-in .currency-text {
  text-align: left;
  padding-left: 33px;
}
.wc-container .wc-container-in .percent-text {
  text-align: right;
  padding-right: 33px;
}
.wc-container .wc-container-in .all-benefits-container,
.wc-container .wc-container-in .offer-description,
.wc-container .wc-container-in .principal-title {
  text-align: left;
}

@media (max-width: 339px) {
  .offer-img {
    width: 100%;
    padding: 0 10px 0 10px;
  }
}
@media only screen and (max-width: 500px) {
  .private-offer-container {
    max-height: 85vh;
    overflow-y: auto;
  }
  .benefits-container.Flex .benefit-icon-img {
    width: 100%;
  }
  .benefits-container.Ahorro .benefit-icon-img {
    width: 100%;
    height: 80%;
  }
  .benefits-container.AhorroSueldo .benefit-icon-img {
    width: 70%;
  }
  .offer-title {
    width: 70%;
  }
}
@media only screen and (max-width: 767px) and (min-width: 510px) {
  .benefits-container.Flex .benefit-icon-img {
    width: 75%;
  }
  .benefits-container.Ahorro .benefit-icon-img {
    width: 75%;
    height: 80%;
    margin-left: 10px;
  }
  .benefits-container.AhorroSueldo .benefit-icon-img {
    width: 50%;
    height: 55%;
    margin-left: 10px;
    margin-top: 7px;
  }
  .text-start-ahorrosueldo {
    text-align: left !important;
    margin-left: 3%;
    width: auto;
  }
  .AhorroSueldo {
    border: none !important;
    margin-bottom: 1rem !important;
  }
}
@media only screen and (min-width: 768px) and (max-width: 992px) {
  .benefits-container.Flex .benefit-icon-img {
    width: 60%;
    margin-left: 15px;
  }
  .benefits-container.Ahorro .benefit-icon-img {
    width: 70%;
    height: 80%;
    margin-left: 15px;
  }
}
@media only screen and (min-width: 993px) {
  .benefits-container.Flex .benefit-icon-img {
    width: 75%;
    margin-left: 5px;
  }
  .benefits-container.Ahorro .benefit-icon-img {
    width: 75%;
    height: 80%;
    margin-left: 15px;
  }
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
